<!--
 * @Author: xiaokun
 * @Date: 2020-03-02 15:55:51
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-03-10 13:35:15
 * @Description: 新建/编辑企业活码-第三步
 -->
<template>
  <div class="code-step-three">
    <!-- 活码创建成功 -->
    <div class="code-create-success">
      <mk-iconfont
        icon-class="success"
        class="code-success-icon"
      />
      <p class="success-text">
        {{ isEdit ? '活码编辑成功' : '活码新增成功' }}
      </p>
    </div>
    <!-- 生成活码 -->
    <div class="common-box active-code-img">
      <div class="active-code-img-left">
        <span>生成活码：</span>
        <img
          :src="codeImg"
          alt="活码"
        >
      </div>
      <div class="active-code-img-right">
        <!-- 下载 -->
        <mk-button-biz
          type="text"
          size="small"
        >
          <!-- 下载 -->
          <a
            :href="codeImg"
            :download="codeName"
          >下载二维码</a>
        </mk-button-biz>
      </div>
    </div>
    <!-- 复制链接 -->
    <div class="common-box active-code-link">
      <div class="active-code-img-right">
        <span class="link-titie">链接：</span>
        <span class="link-text">{{ linkUrl }}</span>
      </div>
      <mk-button-biz
        :data-clipboard-text="linkUrl"
        font-size="13px"
        height="16"
        type="text"
        class="copy-btn"
        @click="copyLinkFun"
      >
        复制链接
      </mk-button-biz>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CodeStepThree',
  components: {},
  props: {
    linkUrl: {
      type: String,
      default: ''
    },
    // 是否是编辑 true:是 fasle:否
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      codeImg: '',
      codeName: '活码'
    }
  },
  methods: {
    // 二维码生成
    async createQrcodeUrl (url) {
      if (url) {
        this.codeImg = await this.$createQrcode(url)
      }
    },
    //  复制链接方法
    copyLinkFun () {
      this.$clipboard('.copy-btn')
    }
  }
}
</script>
<style scoped lang="scss">
.code-step-three {
  max-width: 480px;

  a {
    text-decoration: none;
    color: #009cff;
  }

  .code-create-success {
    .icon-mk-success {
      font-size: 65px;
      color: #15ad31;
    }

    .success-text {
      font-size: 24px;
      color: #000;
      margin: 10px 0 30px;
      line-height: 32px;
    }
  }

  .common-box {
    width: 430px;
    color: #8c8c8c;
    font-size: 13px;
    padding: 15px 25px;
    background-color: #f5f7fd;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  .active-code-img {
    align-items: flex-end;

    .active-code-img-left {
      display: flex;
      align-items: center;

      img {
        border: 10px solid #fff;
        width: 100px;
        height: 100px;
      }
    }
  }

  .active-code-link {
    align-items: flex-start;

    .active-code-img-right {
      display: flex;
      align-items: flex-start;

      .link-titie {
        text-align: right;
        width: 65px;
      }

      .link-text {
        text-align: left;
        word-break: break-all;
        max-width: 280px;
      }
    }
  }
}
</style>
